export function Loading(): JSX.Element {
  return <div className="p-6 text-gray-600">Loading…</div>;
}
